export function getShipModes(){
    return [
        {
            "_id": 'ExS', name : "Entrega a domicilio -  $590 a todo el país", orginalProductId: 30
        },
        {
            "_id": 'RxL', name : "Retiro en local – SIN CARGO(Holmberg 4156,  CABA)", orginalProductId: 310
        }
    ]
}